module.exports = __webpack_public_path__ + "img/ec_open_01.fc90d2f3.jpg";